import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest } from "shared/models/transaction.model";

export const virtualTerminalService = createApi({
  reducerPath: "virtualTerminalService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    createHostedRedirectUrl: builder.mutation<any, TransactionRequest>({
      query: (params) => ({
        url: `/payment-info/redirect-url`,
        method: "POST",
        body: params,
        headers: !params?.skip_log
          ? {
              PageName: "Virtual Terminal",
            }
          : {},
      }),
    }),
    getPartnerIdByMerchantId: builder.query<any, { merchant_id: string }>({
      query: (params) => ({
        url: `/merchant-management/${params.merchant_id}/partnerPMS`,
        method: "GET",
        headers: {
          PageName: "Virtual Terminal",
        },
      }),
    }),
    sendVirtualRefundRequestEmail: builder.mutation<any, any>({
      query: (params) => ({
        url: `/virtual-terminal/send-email`,
        method: "POST",
        body: params,
        headers: !params?.skip_log
          ? {
              PageName: "Virtual Terminal",
            }
          : {},
      }),
    }),
  }),
});

export const {
  useCreateHostedRedirectUrlMutation,
  useLazyGetPartnerIdByMerchantIdQuery,
  useSendVirtualRefundRequestEmailMutation,
} = virtualTerminalService;
